/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptSuccessDto
 */
export interface ReceiptSuccessDto {
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptSuccessDto
     */
    success: boolean;
}

/**
 * Check if a given object implements the ReceiptSuccessDto interface.
 */
export function instanceOfReceiptSuccessDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;

    return isInstance;
}

export function ReceiptSuccessDtoFromJSON(json: any): ReceiptSuccessDto {
    return ReceiptSuccessDtoFromJSONTyped(json, false);
}

export function ReceiptSuccessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptSuccessDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function ReceiptSuccessDtoToJSON(value?: ReceiptSuccessDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

